const DISALLOWED_IMAGE_SRC_RE = /\s+src\s*=\s*(?:"(?:blob:|data:image\/)[^"]*"|'(?:blob:|data:image\/)[^']*'|(?:blob:|data:image\/)[^\s>]*)/i;

function stripOfficeConditionalComments(html) {
    return html
        .replace(/<!--\[if[^\]]*\]>[\s\S]*?<!\[endif\]-->/gi, '')
        .replace(/<!\[if[^\]]*\]>/gi, '')
        .replace(/<!\[endif\]>/gi, '');
}

function stripOfficeNamespaceTags(html) {
    return html.replace(/<\/?(?:xml|o|w|st1):[^>]*>/gi, '').replace(/<\/?xml[^>]*>/gi, '');
}

function stripOfficeAttributes(html) {
    return html.replace(/\sclass=(["'])Mso[^"']*\1/gi, '').replace(/\sstyle=(["'])(?:(?!\1).)*\bmso-[^"']*\1/gi, '');
}

function stripMsoStyleDeclarations(html) {
    return html.replace(/\bmso-[^:;"]+:\s*[^;"]+;?/gi, '');
}

function stripDisallowedPastedImages(html) {
    let removed = false;
    const content = html.replace(/<img\b[^>]*>/gi, tag => {
        if (!DISALLOWED_IMAGE_SRC_RE.test(tag)) {
            return tag;
        }
        removed = true;
        return '';
    });
    return { content, removed };
}

export function sanitizeRichEditorPasteHtml(content) {
    const source = content == null ? '' : String(content);
    // Word/Office 剪贴板里常混入本地图片；只移除图片节点，正文继续交给 TinyMCE 插入。
    const withoutDisallowedImages = stripDisallowedPastedImages(source);
    const sanitized = stripMsoStyleDeclarations(stripOfficeAttributes(stripOfficeNamespaceTags(stripOfficeConditionalComments(withoutDisallowedImages.content))));

    return {
        content: sanitized,
        removedDisallowedImages: withoutDisallowedImages.removed,
    };
}
